/** A column header that sorts its table (#2825). Shared by the console's tables. */
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

import { DataTableHeader } from "../../../components/ui";

export type SortDirection = "asc" | "desc";

export function SortableHeader({
  label,
  active,
  direction,
  onClick,
  testidPrefix,
  align,
}: {
  label: string;
  active: boolean;
  direction: SortDirection;
  onClick: () => void;
  testidPrefix: string;
  align?: "left" | "right" | "center";
}) {
  const Icon = active ? (direction === "asc" ? ArrowUp : ArrowDown) : ArrowUpDown;
  return (
    <DataTableHeader
      {...(align ? { align } : {})}
      aria-sort={active ? (direction === "asc" ? "ascending" : "descending") : "none"}
    >
      <button
        type="button"
        onClick={onClick}
        className="flex items-center gap-1 font-medium uppercase tracking-[0.12em] text-fg-faint transition-colors hover:text-fg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        data-testid={`${testidPrefix}-${label.toLowerCase().replace(/\s+/g, "-")}`}
      >
        <span>{label}</span>
        <Icon className="h-3 w-3" aria-hidden="true" />
      </button>
    </DataTableHeader>
  );
}
